export const typography_kaia = {
  defaultFontFamily: 'PublicSans-Variable, sans-serif',

  displayLarge: {
    fontFamily: 'PublicSans-Variable, sans-serif',
    size: '4rem',
    lineHeight: '4.5rem',
    weight: 700,
    letterSpacing: '-0.02em'
  },
  titleLarge: {
    fontFamily: 'PublicSans-Variable, sans-serif',
    size: '1.75rem',
    lineHeight: '2.25rem',
    weight: 600
  },
  bodyLarge: {
    fontFamily: 'PublicSans-Variable, sans-serif',
    size: '1rem',
    lineHeight: '1.5rem',
    weight: 400
  },
  bodySmall: {
    fontFamily: 'PublicSans-Variable, sans-serif',
    size: '0.875rem',
    lineHeight: '1.25rem',
    weight: 200
  },
  labelMedium: {
    fontFamily: 'PublicSans-Variable, sans-serif',
    size: '0.75rem',
    weight: 500
  }
}
